import { Chip, ChipProps } from '@mui/material'
import { AlertSeverity } from '../enums'
import { translateAlertSeverity } from '../utils/alert'

export interface AlertSeverityChipProps extends Omit<ChipProps, 'label' | 'color'> {
  severity: AlertSeverity
}

export default function AlertSeverityChip({ severity, ...props }: AlertSeverityChipProps) {
  /**
   * The chip color.
   */
  const color =
    severity === AlertSeverity.CRITICAL || severity === AlertSeverity.HIGH
      ? 'error'
      : severity === AlertSeverity.LOW
        ? 'info'
        : 'warning'

  return <Chip color={color} label={translateAlertSeverity(severity)} {...props} />
}
